import {
    AguaUsage,
    AguaUsoRecaudacion,
    AguaUsoUnidades,
    Apertura,
    Importancia,
    ImpuestosAguaDesglose,
    ImpuestosPredialCuentasAcumulados,
    ImpuestosPredialCuentasAcumuladosKey,
    ImpuestosPredialCuentasAcumuladosKeys,
    ImpuestosPredialCuentasDePagos,
    ImpuestosPredialCuentasDePagosKeys,
    ImpuestosPredialCuentasExistente,
    ImpuestosPredialCuentasExistenteKey,
    ImpuestosPredialCuentasExistenteKeys,
    ImpuestosPredialDesglose,
    ImpuestosPredialDesgloseKey,
    ImpuestosPredialDesgloseKeys,
    Notification,
    RegistroImpuestosAgua,
    RegistroImpuestosEstado,
    RegistroImpuestosPredial
} from '../models';

export const defaultApertura: Readonly<Apertura> = {
    ejercicio: NaN,
    mes: NaN,
    fechaInicio: '',
    fechaFin: ''
};

export const defaultImpuestosPredialDesglose: Readonly<ImpuestosPredialDesglose> = {
    impuestoCobrado: 0,
    recargos: 0,
    multas: 0,
    gastosEjecucion: 0,
    interesesNoBancarios: 0,
    indemnizaciones: 0
};

export const defaultImpuestosPredialCuentasExistente: Readonly<ImpuestosPredialCuentasExistente> = {
    numeroDeCuentasUrbano: 0,
    numeroDeCuentasRustico: 0
};

export const defaultImpuestosPredialCuentasDePagos: Readonly<ImpuestosPredialCuentasDePagos> = {
    numeroDePagosEjercicio: 0,
    numeroDePagosEjercicioAnterior: 0,
    numeroDePagosEjercicioMixto: 0
};

export const defaultImpuestosPredialCuentasAcumulados: Readonly<
    ImpuestosPredialCuentasAcumulados
> = {
    numeroDePagosAcumuladoEjercicio: 0,
    numeroDePagosAcumuladoEjercicioAnterior: 0,
    numeroDePagosAcumuladoEjercicioMixto: 0
};

export const defaultAguaDesglose: Readonly<ImpuestosAguaDesglose> = {
    servicioAgua: 0,
    conexiones: 0,
    reconexiones: 0,
    alcantarillado: 0,
    drenaje: 0,
    recargos: 0,
    multas: 0,
    gastosEjecucion: 0,
    interesesNoBancarios: 0,
    indemnizaciones: 0,
    saneamiento: 0
};

export const defaultRegistroImpuestoPredial: Readonly<RegistroImpuestosPredial> = {
    id: NaN,
    estado: RegistroImpuestosEstado.SinCaptura,
    comentarios: '',
    ingresos: {
        isSaved: false,
        ingresosEjercicio: defaultImpuestosPredialDesglose,
        ingresosEjercicioAnterior: defaultImpuestosPredialDesglose
    },
    cuentas: {
        isSaved: false,
        ...defaultImpuestosPredialCuentasExistente,
        ...defaultImpuestosPredialCuentasDePagos,
        ...defaultImpuestosPredialCuentasAcumulados
    },
    descuentos: {
        isSaved: false,
        descuentosEjercicio: defaultImpuestosPredialDesglose,
        descuentosEjercicioAnterior: defaultImpuestosPredialDesglose
    }
};

export const impuestosPredialDesgloseKeys: ImpuestosPredialDesgloseKeys = [
    'impuestoCobrado',
    'recargos',
    'multas',
    'gastosEjecucion',
    'interesesNoBancarios',
    'indemnizaciones'
];

export const impuestosPredialDesgloseConceptosByKey: Record<ImpuestosPredialDesgloseKey, string> = {
    impuestoCobrado: 'IMPUESTO COBRADO',
    recargos: 'RECARGOS',
    multas: 'MULTAS',
    gastosEjecucion: 'GASTOS DE EJECUCIÓN',
    interesesNoBancarios: 'INTERESES (NO BANCARIOS)',
    indemnizaciones: 'INDEMNIZACIONES'
};

export const impuestosPredialCuentasExistenteKeys: ImpuestosPredialCuentasExistenteKeys = [
    'numeroDeCuentasUrbano',
    'numeroDeCuentasRustico'
];

export const impuestosPredialCuentasDePagosKeys: ImpuestosPredialCuentasDePagosKeys = [
    'numeroDePagosEjercicio',
    'numeroDePagosEjercicioAnterior',
    'numeroDePagosEjercicioMixto'
];

export const impuestosPredialCuentasAcumuladosKeys: ImpuestosPredialCuentasAcumuladosKeys = [
    'numeroDePagosAcumuladoEjercicio',
    'numeroDePagosAcumuladoEjercicioAnterior',
    'numeroDePagosAcumuladoEjercicioMixto'
];

export const impuestosPredialCuentasExistenteTiposDePredioByKey: Record<
    ImpuestosPredialCuentasExistenteKey,
    string
> = {
    numeroDeCuentasUrbano: 'URBANO',
    numeroDeCuentasRustico: 'RÚSTICO'
};

export const conceptoKeyNamePairs = new Map<'domestico' | 'noDomestico' | 'otros', string>([
    ['domestico', 'USO DOMÉSTICO'],
    ['noDomestico', 'USO NO DOMÉSTICO (COMERCIAL)'],
    ['otros', 'OTROS USOS (INDUSTRIAL, PRESTADOR DE SERVICIOS)']
]);

export const impuestosAguaDesgloseConceptoKeyNamePairs = new Map<
    keyof ImpuestosAguaDesglose,
    string
>([
    ['servicioAgua', 'SERVICIO DE AGUA'],
    ['conexiones', 'CONEXIONES'],
    ['reconexiones', 'RECONEXIONES'],
    ['alcantarillado', 'ALCANTARILLADO'],
    ['drenaje', 'DRENAJE'],
    ['recargos', 'RECARGOS'],
    ['multas', 'MULTAS'],
    ['gastosEjecucion', 'GASTOS DE EJECUCIÓN'],
    ['interesesNoBancarios', 'INTERESES (NO BANCARIOS)'],
    ['indemnizaciones', 'INDEMNIZACIONES'],
    ['saneamiento', 'SANEAMIENTO']
]);

export const defaultAguaUsoUnidades: AguaUsoUnidades = {
    usuario: 0,
    toma: 0
};

export const defaultAguaUsoRecaudacion: AguaUsoRecaudacion = {
    usuario: 0,
    toma: 0,
    importe: 0
};

export const defaultAguaUsage: AguaUsage<AguaUsoUnidades> = {
    domestico: defaultAguaUsoUnidades,
    noDomestico: defaultAguaUsoUnidades,
    otros: defaultAguaUsoUnidades
};

export const defaultAguaUsageRecaudacion: AguaUsage<AguaUsoRecaudacion> = {
    domestico: defaultAguaUsoRecaudacion,
    noDomestico: defaultAguaUsoRecaudacion,
    otros: defaultAguaUsoRecaudacion
};

export const defaultRegistroImpuestoAgua: Readonly<RegistroImpuestosAgua> = {
    id: NaN,
    estado: RegistroImpuestosEstado.SinCaptura,
    ingresos: {
        isSaved: false,
        ingresosEjercicio: defaultAguaDesglose,
        ingresosEjercicioAnterior: defaultAguaDesglose
    },
    ingresosPorUso: {
        isSaved: false,
        ingresosPorTiposUsoConMedidor: defaultAguaUsageRecaudacion,
        ingresosPorTiposUsoSinMedidor: defaultAguaUsageRecaudacion,
        numeroDePagosEjercicio: defaultAguaUsoUnidades,
        numeroDePagosEjercicioAnterior: defaultAguaUsoUnidades,
        numeroDePagosEjercicioMixto: defaultAguaUsoUnidades
    },
    cuentas: {
        isSaved: false,
        numeroDeCuentasEjercicioConMedidor: defaultAguaUsage,
        numeroDeCuentasEjercicioAnteriorConMedidor: defaultAguaUsage,
        numeroDeCuentasEjercicioSinMedidor: defaultAguaUsage,
        numeroDeCuentasEjercicioAnteriorSinMedidor: defaultAguaUsage,
        numeroCuentasPagosEjercicio: defaultAguaUsoUnidades,
        numeroCuentasPagosEjercicioAnterior: defaultAguaUsoUnidades,
        numeroCuentasPagosEjercicioMixto: defaultAguaUsoUnidades
    },
    descuentos: {
        isSaved: false,
        descuentosEjercicio: defaultAguaDesglose,
        descuentosEjercicioAnterior: defaultAguaDesglose
    },
    comentarios: ''
};

export const defaultNotification: Notification = {
    id: 0,
    titulo: '',
    descripcion: '',
    fechaInicio: '',
    fechaFin: '',
    importancia: Importancia.Bajo,
    leida: false,
    archivosAdjuntos: [],
    audienciaTodosOo: false,
    listaAudienciaOo: [],
    audienciaTodosMunicipios: false,
    listaAudienciaMunicipios: []
};
